import { RouteRecordRaw } from "vue-router";
import DocumentList from "./pages/DocumentList.vue";
import DocumentForm from "./pages/DocumentForm.vue";

export const protectedRoutes: RouteRecordRaw[] = [
    {
        path: "/documents",
        name: "documents",
        component: () => import("./pages/DocumentList.vue"),
        meta: {
            requiresAuth: true,
            title: "Documents",
        },
    },
    {
        path: "/documents/create",
        name: "documents-create",
        component: () => import("./pages/DocumentForm.vue"),
        meta: { requiresAuth: true, title: "Create Document" }
    },
    {
        path: "/documents/:id",
        name: "documents-detail",
        component: () => import("./pages/DocumentDetail.vue"),
        meta: { requiresAuth: true, title: "Document Details" }
    },
    {
        path: "/documents/:id/edit",
        name: "documents-edit",
        component: () => import("./pages/DocumentForm.vue"),
        meta: { requiresAuth: true, title: "Edit Document" }
    }
];
